/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Substatus_Package_LostInputs */

const tr_geliver_substatus_package_lost = /** @type {(inputs: Geliver_Substatus_Package_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket Kayıp`)
};

const en_geliver_substatus_package_lost = /** @type {(inputs: Geliver_Substatus_Package_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Package Lost`)
};

const de_geliver_substatus_package_lost = /** @type {(inputs: Geliver_Substatus_Package_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket verloren`)
};

const ru_geliver_substatus_package_lost = /** @type {(inputs: Geliver_Substatus_Package_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посылка потеряна`)
};

/**
* | output |
* | --- |
* | "Package Lost" |
*
* @param {Geliver_Substatus_Package_LostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_substatus_package_lost = /** @type {((inputs?: Geliver_Substatus_Package_LostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Substatus_Package_LostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_substatus_package_lost(inputs)
	if (locale === "de") return de_geliver_substatus_package_lost(inputs)
	if (locale === "ru") return ru_geliver_substatus_package_lost(inputs)
	return tr_geliver_substatus_package_lost(inputs)
});